import * as tslib_1 from "tslib";
import { Tooltip } from '@nextiva/next-ui';
import cx from 'classnames';
import { noop } from 'lodash';
import * as React from 'react';
import NxDataTable, { Column } from '@nextiva/crm-datatable';
import Styles from "./DataTableBody.css";

var DataTableBody =
/** @class */
function (_super) {
  tslib_1.__extends(DataTableBody, _super);

  function DataTableBody() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isTooltipOpened: false
    };

    _this.handleSelectRow = function (e, item) {
      if (item.rowOptions && item.rowOptions.disabled) {
        _this.setState({
          isTooltipOpened: true
        });
      } else if (_this.props.onRowClick) {
        _this.props.onRowClick(e, item);
      }
    };

    return _this;
  }

  DataTableBody.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        data = _a.data,
        isLoading = _a.isLoading,
        displayPreferences = _a.displayPreferences,
        getRenderer = _a.getRenderer,
        renderActions = _a.renderActions,
        filterData = _a.filterData,
        sortData = _a.sortData,
        onSortChange = _a.onSortChange,
        onFiltersChange = _a.onFiltersChange,
        disabledRowTooltipMessage = _a.disabledRowTooltipMessage; //todo other props

    var isTooltipOpened = this.state.isTooltipOpened;
    return React.createElement("div", {
      className: cx(Styles.body, className)
    }, React.createElement(NxDataTable, {
      isLoading: isLoading,
      data: data,
      renderActions: renderActions,
      displayPreferences: displayPreferences,
      onSortChange: onSortChange,
      onFiltersChange: onFiltersChange,
      onRowClick: this.handleSelectRow,
      checkable: false,
      disableGear: true
    }, displayPreferences.filter(function (p) {
      return p.display;
    }).map(function (item) {
      var props = {
        name: item.name,
        type: item.type,
        width: item.width,
        resizable: item.resizable,
        options: item.options || [],
        isFixedFilter: !!item.options,
        getCellData: function getCellData(rowData, name) {
          return rowData[name];
        },
        shouldRenderSort: !!item.sortable,
        shouldRenderFilter: !!item.filterable,
        cellRenderer: undefined,
        filterData: undefined,
        order: undefined,
        draggableOpts: {
          enableUserSelectHack: false
        }
      };
      var customRenderer = getRenderer(item.name);

      if (customRenderer) {
        props.cellRenderer = customRenderer;
      }

      if (filterData && filterData[item.name]) {
        props.filterData = filterData[item.name];
      }

      if (sortData && sortData.key === item.name) {
        props.order = sortData.order;
      }

      return React.createElement(Column, tslib_1.__assign({
        key: item.name
      }, props), item.label);
    })), disabledRowTooltipMessage && React.createElement(Tooltip, {
      dark: true,
      placement: "bottom",
      text: disabledRowTooltipMessage,
      isOpen: isTooltipOpened,
      popoverClassName: Styles.tablePopover
    }));
  };

  DataTableBody.defaultProps = {
    isLoading: false,
    data: [],
    displayPreferences: [],
    filterData: null,
    sortData: null,
    onRowClick: noop,
    getRenderer: noop,
    cellRenderer: noop,
    onFiltersChange: noop,
    onSortChange: noop,
    disabledRowTooltipMessage: null
  };
  return DataTableBody;
}(React.Component);

export default DataTableBody;